
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Qu’est-ce qu’un CMS, Content Management System ? Le guide complet",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Un CMS, ou Content Management System, est un logiciel qui permet de créer, gérer et modifier facilement un site web sans nécessiter de compétences techniques approfondies en programmation ou en développement web.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Qu’est-ce qu’un CMS, Content Management System ? Le guide complet",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Un CMS, ou Content Management System, est un logiciel qui permet de créer, gérer et modifier facilement un site web sans nécessiter de compétences techniques approfondies en programmation ou en développement web.",
        },
      ],
    };
  },
};
